// extracted by mini-css-extract-plugin
module.exports = {"error-message__border":"style_error-message__border__82_DI","error-message__text":"style_error-message__text__OuIV7"};